import algosdk from "algosdk";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useWallet } from "../context/WalletContext";
import { useTransaction } from "../context/TransactionContext";
import "../styles/general.css";
import "../styles/eventos.css";

interface Item {
  id: string;
  name: string;
  image: string;
  description: string;
  price?: number;
  category: "AliadosEventos" | "MoxServicios";
  creatorAddress?: string; 
  input?: number; 
}

const items: Item[] = [
  {
    id: "Taller Trading I",
    name: "Taller Trading 15 de Marzo",
    image: "/images/frontend/Combo C.png",
    description: "Ingresa UMQ para apoyar al creador y reservar tu demo",
    category: "AliadosEventos",
    description: "Entrada general para nuestro primer taller.",
    price: "GRATIS",
    creatorAddress:
      "ELUQDUK22ZHG2GVHMDUM54WWYKSDPUDVCUJMD5ZNNMLSMG7V6UQVXWBREI",
  },
  {
    id: "Space X",
    name: "Space X de socializacion",
    image: "/images/frontend/vote.jpeg", 
    description: "Entrada general para nuestro primer taller.",
    price: "GRATIS",
    category: "AliadosEventos",
    creatorAddress:
      "ELUQDUK22ZHG2GVHMDUM54WWYKSDPUDVCUJMD5ZNNMLSMG7V6UQVXWBREI",
  },
  {
    id: "EVENTO01",
    name: "Espacio Disponible",
    image: "/images/usdc_mox.png",
    description: "Ingresa UMQ para apoyar al creador y reservar",
    price: "GRATIS",
    category: "AliadosEventos",
    creatorAddress:
      "ELUQDUK22ZHG2GVHMDUM54WWYKSDPUDVCUJMD5ZNNMLSMG7V6UQVXWBREI",
  },
  {
    id: "EVENTO02",
    name: "Presentación demo",
    image: "/images/adopcion.png",
    description: "Ingresa UMQ para apoyar al creador y reservar",
    price: 500,
    category: "AliadosEventos",
    creatorAddress:
      "ELUQDUK22ZHG2GVHMDUM54WWYKSDPUDVCUJMD5ZNNMLSMG7V6UQVXWBREI",
  },
];

const Marketplace = ({
  algodClient,
  setMessage,
}: {
  algodClient: algosdk.Algodv2;
  setMessage: (msg: string) => void;
}) => {
  const { account } = useWallet();
  const { openTransactionModal } = useTransaction();
  const accountAddress = account?.addr || "";
  const navigate = useNavigate();
  const [marketItems, setMarketItems] = useState<Item[]>(items);

  const asaId = 748884896; 

  const handleInputChange = (id: string, value: string) => {
    const numericValue = Number(value);
    setMarketItems((prev) =>
      prev.map((e) =>
        e.id === id ? { ...e, input: isNaN(numericValue) ? undefined : numericValue } : e
      )
    );
  };

  const handleSendToCreator = (item: Item) => {
  if (!item.input || item.input <= 0) {
    setMessage("❌ Monto inválido");
    return;
  }

  openTransactionModal({
    recipient: item.creatorAddress!,
    amount: item.input,
    asset: { name: "UMQ", id: asaId, decimals: 9 },

    onConfirm: async () => {
      try {
        const suggestedParams = await algodClient.getTransactionParams().do();
        const baseAmount = item.input! * 1e9;
        const tx = algosdk.makeAssetTransferTxnWithSuggestedParamsFromObject({
          from: accountAddress,
          to: item.creatorAddress!,
          assetIndex: asaId,
          amount: baseAmount,
          suggestedParams,
        });

        const signedTx = tx.signTxn(account!.sk);
        const { txId } = await algodClient.sendRawTransaction(signedTx).do();

        setMessage(`✅ UMQ enviados a ${item.name} - TxID: ${txId}`);
      } catch (err) {
        console.error(err);
        setMessage("❌ Error durante la transacción.");
      }
    },

    feeAlgo: undefined,   
    feeProject: 0,       
  });
};

  return (
    <div className="modal-marketplace">
      <h1>Programate, valora y gana</h1>
<section>
  <div className="items-grid">
    {marketItems
      .filter((item) => item.category === "AliadosEventos")
      .map((item) => (
        <div key={item.id} className="item-card">
          <img src={item.image} alt={item.name} width="200" />
          <h4>{item.name}</h4>
          <strong>{item.price} UMQ</strong> 
          <p>{item.description}</p>
          <input
  type="number"
  min="0.001"
  step="0.001"
  placeholder="Ingresa UMQ a enviar"
  value={item.input !== undefined ? item.input : ""}
  onChange={(e) => handleInputChange(item.id, e.target.value)}
  className="input-umq"
/>
          
          <button
            className="button-primary"
            onClick={() => handleSendToCreator(item)}
          >
            Enviar UMQ al creador
          </button>
        </div>
      ))}
  </div>
</section>
<button className="button-exit" onClick={() => navigate("/home")}>Volver</button>
    </div>
  );
};

export default Marketplace;
                  